__turbopack_context__.v({
  "agenda": "CSrF4a_agenda",
  "agendaDesc": "CSrF4a_agendaDesc",
  "agendaItem": "CSrF4a_agendaItem",
  "agendaTime": "CSrF4a_agendaTime",
  "audienceList": "CSrF4a_audienceList",
  "benefitContent": "CSrF4a_benefitContent",
  "benefitDesc": "CSrF4a_benefitDesc",
  "benefitItem": "CSrF4a_benefitItem",
  "benefitNumber": "CSrF4a_benefitNumber",
  "benefitTitle": "CSrF4a_benefitTitle",
  "benefits": "CSrF4a_benefits",
  "ctaButton": "CSrF4a_ctaButton",
  "currentPrice": "CSrF4a_currentPrice",
  "disclaimer": "CSrF4a_disclaimer",
  "faqItem": "CSrF4a_faqItem",
  "faqList": "CSrF4a_faqList",
  "finalCta": "CSrF4a_finalCta",
  "finalCtaSubtitle": "CSrF4a_finalCtaSubtitle",
  "finalCtaTitle": "CSrF4a_finalCtaTitle",
  "footer": "CSrF4a_footer",
  "footerLink": "CSrF4a_footerLink",
  "guarantee": "CSrF4a_guarantee",
  "header": "CSrF4a_header",
  "hero": "CSrF4a_hero",
  "label": "CSrF4a_label",
  "logoLink": "CSrF4a_logoLink",
  "main": "CSrF4a_main",
  "meta": "CSrF4a_meta",
  "metaDivider": "CSrF4a_metaDivider",
  "metaItem": "CSrF4a_metaItem",
  "originalPrice": "CSrF4a_originalPrice",
  "page": "CSrF4a_page",
  "priceDisplay": "CSrF4a_priceDisplay",
  "priceNote": "CSrF4a_priceNote",
  "pricingContent": "CSrF4a_pricingContent",
  "pricingSection": "CSrF4a_pricingSection",
  "saveBadge": "CSrF4a_saveBadge",
  "section": "CSrF4a_section",
  "sectionHeader": "CSrF4a_sectionHeader",
  "sectionTitle": "CSrF4a_sectionTitle",
  "subtitle": "CSrF4a_subtitle",
  "title": "CSrF4a_title",
});
